module.exports = __webpack_public_path__ + "img/certificate-en.44b3ba55.png";